import "./reproductive";
import "./endocrine";
import "./structural";
import "./male-factor";
import "./autoimmune";
import "./mullerian";
import "./male-factor-specific";
import "./luteal-phase-defect";
import "./cervical-stenosis";
